import { jsxs, jsx } from 'react/jsx-runtime';
import { Box, Typography } from '@vp/swan';
import 'react';
import { useMainContext } from '../../../../../contexts/MainContext.js';

const EmptyOrders=()=>{const{t}=useMainContext();return jsxs(Box,{"data-cy":"loggedin-no-orders",className:"no-orders",children:[jsx(Typography,{"data-cy":"loggedin-no-orders-title",fontSize:"standard",fontWeight:"bold",children:t("replacement.order.logged_in.no_orders.title")}),jsx(Typography,{pt:"7",fontSize:"small",children:t("replacement.order.logged_in.no_orders.sub_1")})]})};

export { EmptyOrders };
//# sourceMappingURL=EmptyOrders.js.map
